import { Table } from "../../../features/Table";
import { type A9Portfolio, porfolios_columns } from "./columns";
import { type FilterA9PortfoliosSchema, FilterA9Portfolios } from "./filter";

const client = "a9";
const table_name = "a9_portfolios";

export const A9PortfoliosTable = () => {
  return (
    <Table<A9Portfolio, FilterA9PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterA9Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
